function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTropfsicherUndTransparent = function SvgTropfsicherUndTransparent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 115.33 95.84"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M57.54 4.36 0 34.62l29.43 15.52L.25 65.49l57.54 30.35 57.54-30.26L85.9 50.06l29.18-15.35-27.92-14.73c-.18.89-.49 1.77-.92 2.61L109.2 34.7l-.84.44-50.82 26.73L5.88 34.62l.84-.44L57.54 7.46l9.48 5 1.4-2.36zm0 60.61L82.96 51.6l26.49 13.97-.84.44-50.82 26.73L6.13 65.49l26.24-13.8z",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m84.45 13.02-6.8-11.47c-.19-.32-.55-.52-.93-.52s-.73.2-.93.52l-6.8 11.47s-.02.03-.03.06c-1.58 2.71-1.57 5.94.03 8.64 1.61 2.72 4.5 4.35 7.73 4.35s6.11-1.63 7.73-4.35c.04-.07.08-.15.12-.23.02-.05.04-.09.07-.14.44-.83.74-1.7.89-2.59.34-2-.03-3.98-1.08-5.75Z",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeMiterlimit: 10,
      strokeWidth: "2.05px"
    }
  }));
};
export default SvgTropfsicherUndTransparent;